import type { NodeRu } from '../i18n';

/** Russian overlays for knowledge-node labels, keyed by node id. */
export const nodesRu: Record<string, NodeRu> = {
  // ── Domains ──────────────────────────────────────────────────────────────
  ai: { label: 'Искусственный интеллект' },
  'agents-domain': { label: 'Агенты' },
  'knowledge-domain': { label: 'Знания' },
  'learning-domain': { label: 'Человеко-машинное обучение' },
  'computation-domain': { label: 'Вычисления' },
  'theory-domain': { label: 'Теория' },

  // ── Agents branch ────────────────────────────────────────────────────────
  'multi-agent': { label: 'Мультиагентные системы' },
  'agent-native': { label: 'Agent-native программное обеспечение' },
  'agent-economy': { label: 'Экономики ресурсов' },
  consensus: { label: 'Византийское согласие' },
  'recursive-organization': { label: 'Рекурсивная организация' },
  orchestration: { label: 'Оркестрация агентов' },
  'autonomy-gating': { label: 'Автономность с порогом уверенности' },

  // ── Knowledge branch ─────────────────────────────────────────────────────
  'knowledge-graph': { label: 'Графы знаний' },
  'semantic-retrieval': { label: 'Семантический поиск' },
  provenance: { label: 'Происхождение знаний' },
  'dynamic-weights': { label: 'Динамические веса' },
  'adaptive-maps': { label: 'Адаптивные карты' },

  // ── Learning branch ──────────────────────────────────────────────────────
  mastery: { label: 'Модели усвоения' },
  'gap-diagnostics': { label: 'Диагностика пробелов' },
  'adaptive-paths': { label: 'Адаптивные траектории обучения' },

  // ── Computation branch ───────────────────────────────────────────────────
  'numerical-stability': { label: 'Численная устойчивость' },
  'compensated-arithmetic': { label: 'Компенсационная арифметика' },
  'spiking-networks': { label: 'Импульсные сети' },
  'local-learning': { label: 'Локальные правила обучения' },
  'structural-growth': { label: 'Структурный рост' },

  // ── Theory branch ────────────────────────────────────────────────────────
  falsifiability: { label: 'Фальсифицируемые утверждения' },
  'experiment-registry': { label: 'Реестр экспериментов' },
};
